"use client"

import { cn } from "@workspace/ui/lib/utils"

import { useAnalytics } from "./analytics-provider"

/** Footer "Cookie settings" link; reopens the consent banner. Hidden without a tag. */
export function ConsentSettingsLink({
  label,
  className,
}: {
  label: string
  className?: string
}) {
  const { tag, openSettings } = useAnalytics()
  if (!tag) return null
  return (
    <button
      type="button"
      onClick={openSettings}
      className={cn(
        "text-xs text-neutral-500 underline-offset-4 transition-colors hover:text-white hover:underline",
        className
      )}
    >
      {label}
    </button>
  )
}
